import React, { useState } from "react";
import { Button, Card, Container } from "react-bootstrap";
import { useSelector } from "react-redux";
import { getUser } from "../../../../controller/reducer/user";
import UserDeleteModal from "../delete";
import "./styles.css";

function UserCard({ user, dispatch }) {
  const _user = useSelector(getUser);
  const [show, setShow] = useState(false);
  return (
    <Container fluid>
      <Card border="info">
        <Card.Body>
          <Card.Title className="text-center">{user.name}</Card.Title>
          <Card.Text className="text-center d-flex justify-content-between">
            <Button
              variant={`${user.type === "root" ? "success" : user.type === "admin" ? "warning" : "primary"} mr-2`}
              size="sm"
            >
              {user.type}
            </Button>
            <Card.Link
              className="text-truncate"
              target="_blank"
              style={{ display: "table-cell" }}
              href={user.email}
            >
              {user.email}
            </Card.Link>
            {_user.type==="root" && <Button
              // variant="warning"
              style={{
                background: "#ffa500",
                color: "black",
                border: "none",
                fontWeight: "500",
              }}
              size="sm"
              onClick={() => setShow(true)}
            >
              Delete
            </Button>}
          </Card.Text>

          <UserDeleteModal
          dispatch={dispatch}
          show={show}
          onClose={() => setShow(false)}
          user={user}
        />
        </Card.Body>
      </Card>
    </Container>
  );
}

export default UserCard;
